{
  "it": {
    "labels": {
      "true": "Si",
      "false": "No",
      "null": "-",
      "supporter": {
        "badge": "Sostenitore",
        "tooltip": "Sostiene FleetYards.net questo mese"
      },
      "destroyedFleets": {
        "discarded": "Scartata",
        "purged": "Eliminata definitivamente"
      },
      "and": "e",
      "hide": "Nascondi",
      "show": "Mostra",
      "only": "Solo",
      "description": "Descrizione",
      "unavailable": "non disponibile",
      "selected": "Selezionati",
      "actions": "Azioni",
      "status": "Stato",
      "enabled": "Abilitato",
      "disabled": "Disabilitato",
      "collapse": "Comprimi",
      "price": "Prezzo",
      "expand": "Espandi",
      "distance": "Distanza",
      "anonymous": "Anonimo",
      "refreshing": "Aggiornamento...",
      "toggleNavigation": "Attiva/disattiva navigazione",
      "openInNewWindow": "Apri a schermo intero",
      "or": "o",
      "networkStatusOffline": "Stato Della Rete: Offline - Servizio Non Disponibile",
      "groups": "Gruppi",
      "classifications": "Classificazioni",
      "features": {
        "stateOn": "Abilitato",
        "stateOff": "Disabilitato",
        "stateConditional": "Condizionale",
        "selfService": "Self-service",
        "actors": "Attori",
        "groups": "Gruppi",
        "noGroups": "Nessun gruppo abilitato per questa funzione.",
        "noActors": "Nessun attore individuale abilitato per questa funzione.",
        "user": "Utente",
        "fleet": "Flotta",
        "actorType": "Tipo di attore",
        "percentageOfActors": "degli attori",
        "percentageOfTime": "del tempo",
        "currentState": "Stato attuale",
        "toggle": "Attiva/Disattiva",
        "settingsIntro": "Attiva o disattiva le funzioni sperimentali per il tuo account. Queste funzioni potrebbero essere incomplete o cambiare senza preavviso.",
        "descriptions": {
          "tools_travel_times": "Mostra i tempi di viaggio stimati tra le posizioni.",
          "tools_cargo_grids": "Mostra il visualizzatore interattivo della griglia di carico per le navi.",
          "fleet_starmap": "Mostra la mappa stellare di Star Citizen nelle pagine dei membri della flotta."
        },
        "registryHint": "I flag sono dichiarati in config/feature_flags.yml e creati al deploy. Qui ne controlli le condizioni di attivazione.",
        "fleetSettingsIntro": "Attiva o disattiva le funzionalità per tutta la flotta. Ogni membro vede ciò che attivi qui.",
        "fleetFeature": "Funzionalità della flotta",
        "fleetFeatureInfo": "Attivandola qui vale solo per te. Gli amministratori della tua flotta possono attivarla per tutta la flotta.",
        "toggleForSelf": "Attiva solo per te",
        "fleetFeatureGrantedShort": "Attivato dalla flotta",
        "fleetFeatureGranted": "La tua flotta l'ha attivata per tutti i membri, quindi non può essere disattivata qui.",
        "groupFeatureGrantedShort": "Attivato dal gruppo",
        "groupFeatureGranted": "Un gruppo di cui fai parte ha questa funzionalità attiva, quindi non può essere disattivata qui.",
        "groupFeatureGrantedFleet": "Un gruppo di cui fa parte questa flotta ha questa funzionalità attiva, quindi non può essere disattivata qui.",
        "managedFeatureShort": "Gestito",
        "managedFeature": "Questa funzionalità è stata attivata per il tuo account e non può essere modificata qui.",
        "managedFeatureFleet": "Questa funzionalità è stata attivata per questa flotta e non può essere modificata qui.",
        "selfServiceUser": "Gli utenti possono attivarla",
        "selfServiceFleet": "Gli amministratori della flotta possono attivarla"
      },
      "oauthApplication": {
        "name": "Nome applicazione",
        "clientId": "ID client",
        "clientSecret": "Segreto client",
        "redirectUri": "URI di reindirizzamento",
        "redirectUriHint": "Usare un URI per riga.",
        "confidential": "Riservato",
        "scopes": "Ambiti",
        "scopesHint": "Se non vengono selezionati ambiti, verranno utilizzati quelli predefiniti: %{scopes}"
      },
      "rsiRequestLogs": {
        "resolved": "Risolto",
        "unresolved": "Non risolto"
      },
      "imports": {
        "type": "Tipo",
        "status": "Stato",
        "version": "Versione",
        "startedAt": "Avviato",
        "finishedAt": "Terminato",
        "failedAt": "Fallito il",
        "info": "Info",
        "input": "Input",
        "output": "Output",
        "importData": "Dati di importazione",
        "file": "File importato",
        "requestedBy": "Richiesto da",
        "adminUser": "Utente admin",
        "user": "Utente",
        "includeSystem": "Includi sistema",
        "systemRequester": "sistema",
        "statuses": {
          "created": "In coda",
          "started": "In corso",
          "finished": "Terminato",
          "failed": "Fallito"
        }
      },
      "oauthApplications": {
        "settingsIntro": "Gestisci le tue applicazioni OAuth. Queste applicazioni possono accedere all'API di FleetYards per conto degli utenti.",
        "name": "Nome applicazione",
        "redirectUri": "URI di reindirizzamento",
        "confidential": "Riservato",
        "clientId": "ID client",
        "clientSecret": "Segreto client",
        "scopes": "Ambiti",
        "defaultScopes": "Ambiti predefiniti",
        "confidentialShort": "Riservato",
        "publicShort": "Pubblico"
      },
      "fleetInviteToken": "Inviti Alla Flotta",
      "scDataVersion": "Versione Della Patch",
      "createdAt": "Creato il",
      "updatedAt": "Aggiornato il",
      "addToHangar": "Aggiungi all'hangar",
      "home": {
        "search": "Cerca Navi..."
      },
      "shop": {
        "sellPrice": "vende per",
        "buyPrice": "compra per"
      },
      "shopCommodity": {
        "item": "Articolo",
        "shop": "Negozio",
        "buyPrices": "Prezzo d'Acquisto",
        "rentalPrices": "Prezzo di Noleggio",
        "confirmed": "Confermato?",
        "prices": {
          "label": "Prezzi",
          "sellPrice": "vende per",
          "buyPrice": "compra per"
        }
      },
      "stats": {
        "quickStats": {
          "newShips": "Nuove navi in %{year}",
          "totalShips": "Navi Totali",
          "totalMembers": "Membri Totali",
          "vehicles": "Navi in hangar",
          "wishlists": "Navi nella lista dei desideri",
          "shipOfTheMonth": "Nave del mese"
        },
        "modelsByClassification": "Navi per Classificazione",
        "modelsBySize": "Navi per Dimensioni",
        "vehiclesByModel": "Navi per Modello (Top %{limit})",
        "modelsPerMonth": "Navi al Mese",
        "modelsByManufacturer": "Navi per Produttore",
        "modelsByProductionStatus": "Navi per Stato di Produzione",
        "vehiclesPerMonth": "Navi in hangar al mese",
        "topVehiclesByModel": "Top 10 navi in hangar",
        "shipsOfTheMonth": "Nave del mese",
        "trendingShips": "Navi più viste (30 giorni)",
        "wishlistByModel": "Navi più desiderate",
        "wishToOwnRatio": "Desiderate ogni 100 possedute",
        "topPaints": "Vernici più popolari",
        "paintedVehicles": "Navi verniciate",
        "pledgePriceChanges": "Variazioni di prezzo pledge (12 mesi)",
        "mostWishlisted": "Navi più desiderate questo mese",
        "patchChanges": "Più modificate da questa patch",
        "crewDeficit": "Deficit equipaggio",
        "crewSurplus": "Surplus equipaggio",
        "membersByRole": "Membri per ruolo",
        "csv": {
          "metric": "Metrica",
          "value": "Valore",
          "count": "Conteggio"
        }
      },
      "roadmap": {
        "releases": "Rilasci",
        "released": "Rilasciato",
        "lastVersion": {
          "active": {
            "false": "Elemento rimosso dalla roadmap",
            "true": "Elemento riagiunto alla roadmap",
            "decreased": "L'Elemento é stato rimosso dalla Roadmap",
            "increased": "L'Elemento è stato ri-aggiunto alla Roadmap"
          },
          "released": "L'Elemento rilasciato nel PU",
          "release": "L'Elemento è stato spostato dalla versione %{old} alla %{new}"
        },
        "stories": {
          "one": "%{count} Storia",
          "other": "%{count} Storie"
        },
        "tasks": {
          "one": "of %{count} Task",
          "other": "of %{count} Tasks"
        },
        "ships": {
          "one": "%{count} Nave",
          "other": "%{count} Navi"
        }
      },
      "unknown": "Sconosciuto",
      "none": "-",
      "notAvailable": "N/A",
      "not-available": "N/A",
      "name": "Nome",
      "homepage": "Homepage",
      "discord": "Server Discord",
      "youtube": "Canale YouTube",
      "twitch": "Canale Twitch",
      "guilded": "Server Guilded",
      "3dView": "3D",
      "3dMap": "Map",
      "filter": "Filtra",
      "taxExcluded": "IVA esclusa",
      "hangar": "Hangar",
      "public": "Pubblico",
      "hangarStats": "Statistiche",
      "wishlist": "Lista dei desideri",
      "fleetchart": "Grafico flotta",
      "fleetchartApp": {
        "screenHeight": "Altezza dello schermo",
        "viewpoint": "Punto di vista",
        "screenHeightOptions": {
          "1x": "1x",
          "1_5x": "1.5x",
          "2x": "2x",
          "3x": "3x",
          "4x": "4x"
        },
        "viewpointOptions": {
          "side": "Lato",
          "top": "Alto",
          "angled": "Angolato",
          "front": "Fronte"
        },
        "gridSize": "%{size} metro per cella della griglia",
        "mode": "Modalità",
        "modeOptions": {
          "classic": "Classico",
          "panzoom": "v2"
        }
      },
      "fleetStats": "Statistiche",
      "hangarMetrics": {
        "total": "Totale",
        "totalMoney": "Valore Monetario",
        "totalCredits": "Credits",
        "totalIngameValue": "Valore aUEC hangar",
        "totalMinCrew": "Min. Equipaggio",
        "totalMaxCrew": "Max. Equipaggio",
        "totalCargo": "Carico Totale",
        "largestShip": "Nave più grande",
        "smallestShip": "Nave più piccola",
        "averagePledgePrice": "Prezzo Pledge medio",
        "flightReady": "Pronto al volo",
        "uniqueModels": "Modelli unici",
        "manufacturerCount": "Produttori",
        "missingClassifications": "Ruoli mancanti",
        "wishlistTotalMoney": "Valore Pledge lista dei desideri",
        "wishlistTotalCredits": "Valore in gioco lista dei desideri"
      },
      "selectModel": "Seleziona una Nave",
      "findModel": "Scrivi per cercare una nave",
      "find": "Scrivi per cercare",
      "selectUser": "Seleziona un utente",
      "findUser": "Digita per trovare un utente",
      "selectAdminUser": "Seleziona un utente admin",
      "selectFleet": "Seleziona una flotta",
      "findFleet": "Digita per trovare una flotta",
      "compare": {
        "removeModel": "Rimuovi Nave",
        "addModel": {
          "nullablePrompt": "Aggiungi una Nave"
        },
        "enough": "Non pensi che 8 navi siano sufficienti? ;)",
        "shipCount": {
          "one": "%{count} nave",
          "other": "%{count} navi"
        },
        "containersOfSize": "Container da %{size} SCU",
        "armorHp": "HP corazza",
        "fuelAndQuantum": "Carburante e Quantum",
        "weaponPoolSize": "Riserva energetica armi",
        "crossSection": {
          "x": "Sezione trasversale X",
          "y": "Sezione trasversale Y",
          "z": "Sezione trasversale Z"
        },
        "useAsBaseline": "Usa come riferimento",
        "baseline": "Riferimento",
        "differencesOnly": "Solo le differenze",
        "compareToBaseline": "Confronta con il riferimento",
        "loadoutBySlot": "Configurazione per slot",
        "slots": {
          "guns": "Armi principali",
          "turrets": "Torrette",
          "missiles": "Missili",
          "shields": "Generatori di scudi",
          "powerPlants": "Generatori",
          "coolers": "Refrigeranti",
          "quantumDrives": "Motori Quantum",
          "thrusters": "Propulsori principali",
          "countermeasures": "Contromisure"
        },
        "legend": {
          "best": "migliore della riga",
          "worst": "peggiore",
          "share": "quota rispetto al migliore della riga",
          "better": "supera il riferimento",
          "worse": "resta indietro"
        },
        "selectShips": "Seleziona navi"
      },
      "au": "AU",
      "uec": "aUEC",
      "sell": "Vendi",
      "buy": "Compra",
      "yourFlagship": "La tua Ammiraglia",
      "flagship": "Ammiraglia",
      "fleet": {
        "destroyInfo": "If you want to delete this Fleet and remove all its information from Fleetyards.net click the button below. Be aware that this is a permanent action and can't be reverted.",
        "classes": "Flotta",
        "fid": "ID Flotta",
        "name": "Nome",
        "logo": "Logo",
        "rsiSid": "SID",
        "description": "Descrizione",
        "public": "Fleetview Pubblica",
        "publicFleet": "Flotta pubblica",
        "publicStats": "Statistiche pubbliche",
        "publicFleetStats": "Statistiche flotta pubbliche",
        "discord": {
          "url": "Server Discord",
          "hint": "Collega un server Discord per rispecchiare gli eventi come eventi programmati nativi. I membri possono rispondere da Discord e l'iscrizione verrà sincronizzata su Fleetyards.",
          "guildId": "ID del server Discord",
          "channelId": "ID del canale vocale (facoltativo)",
          "webhookUrl": "URL del webhook per gli annunci (facoltativo)",
          "installBotHint": "Apre la pagina di installazione di Discord in una nuova scheda — scegli il server su cui vuoi rispecchiare gli eventi.",
          "statusOk": "Connesso a %{name}",
          "statusCodes": {
            "missing_token": "Il bot Fleetyards non è configurato lato server. Contatta un amministratore.",
            "missing_guild": "Inserisci prima un ID del server Discord.",
            "invalid_token": "Il token del bot non è valido. Contatta un amministratore.",
            "bot_not_in_guild": "Il bot non è presente in questo server. Usa il link di installazione per aggiungerlo.",
            "guild_not_found": "Discord non riconosce questo ID del server. Ricontrolla il valore.",
            "discord_error": "Discord ha restituito un errore imprevisto.",
            "request_failed": "Non è stato possibile raggiungere Fleetyards. Riprova."
          }
        },
        "guilded": "Server Guilded",
        "homepage": "Homepage",
        "twitch": "Canale Twitch",
        "youtube": "Canale Youtube",
        "backgroundImage": "Immagine di sfondo",
        "ts": "Server Teamspeak",
        "awaitingConfirmation": "In attesa di conferma dalla Flotta",
        "members": {
          "primary": "Flotta Primaria?",
          "shipsFilter": {
            "label": "Quali navi dovrebbero essere aggiunte alla flotta?",
            "nullablePrompt": "Nessuna opzione selezionata",
            "field": "Seleziona Navi",
            "values": {
              "all": "Tutte le navi",
              "hangar_group": "Tutte le navi in un dato gruppo Hangar",
              "hide": "Nessuna Nave"
            }
          },
          "hangarGroupId": {
            "field": "Gruppo Hangar",
            "label": "Specifica un Gruppo Hangar",
            "nullablePrompt": "Nessun Gruppo selezionato"
          },
          "total": "Totale: %{count}",
          "joined": "Iscritto il",
          "invited": "Invitato",
          "invitedAt": "Invitato / Richiesto il",
          "requested": "Iscrizione Richiesta",
          "declined": "Rifiutata",
          "pending": "Inviti e richieste in attesa",
          "accepted": "Membri",
          "role": "Ruolo",
          "roles": {
            "admin": "Admin",
            "officer": "Ufficiale",
            "member": "Membro"
          },
          "contact": "Contact",
          "spectrumDm": "Message on Spectrum",
          "discordContact": "Discord"
        },
        "roles": {
          "permanent": "Permanente",
          "privilegeGroups": {
            "fleet": "Flotta",
            "memberships": "Membri",
            "invites": "Inviti",
            "vehicles": "Veicoli",
            "roles": "Ruoli",
            "inventories": "Inventari",
            "missions": "Missioni",
            "events": "Eventi",
            "notifications": "Notifiche"
          },
          "privileges": {
            "fleet:update": "Aggiorna flotta",
            "fleet:update:images": "Aggiorna immagini",
            "fleet:update:description": "Aggiorna descrizione",
            "fleet:delete": "Elimina flotta",
            "fleet:manage": "Gestisci flotta",
            "fleet:memberships:read": "Visualizza membri",
            "fleet:memberships:create": "Invita membri",
            "fleet:memberships:update": "Aggiorna membri",
            "fleet:memberships:delete": "Rimuovi membri",
            "fleet:memberships:manage": "Gestisci membri",
            "fleet:invites:read": "Visualizza inviti",
            "fleet:invites:create": "Crea inviti",
            "fleet:invites:update": "Aggiorna inviti",
            "fleet:invites:delete": "Elimina inviti",
            "fleet:invites:manage": "Gestisci inviti",
            "fleet:vehicles:read": "Visualizza veicoli",
            "fleet:vehicles:create": "Aggiungi veicoli",
            "fleet:vehicles:update": "Aggiorna veicoli",
            "fleet:vehicles:delete": "Rimuovi veicoli",
            "fleet:vehicles:manage": "Gestisci veicoli",
            "fleet:roles:read": "Visualizza ruoli",
            "fleet:roles:create": "Crea ruoli",
            "fleet:roles:update": "Aggiorna ruoli",
            "fleet:roles:delete": "Elimina ruoli",
            "fleet:roles:manage": "Gestisci ruoli",
            "fleet:inventories:read": "Visualizza inventari",
            "fleet:inventories:create": "Crea inventari",
            "fleet:inventories:update": "Aggiorna inventari",
            "fleet:inventories:delete": "Elimina inventari",
            "fleet:inventories:manage": "Gestisci inventari",
            "fleet:missions:read": "Visualizza missioni",
            "fleet:missions:create": "Crea missioni",
            "fleet:missions:update": "Aggiorna missioni",
            "fleet:missions:delete": "Elimina missioni",
            "fleet:missions:manage": "Gestisci missioni",
            "fleet:events:read": "Visualizza eventi",
            "fleet:events:create": "Crea eventi",
            "fleet:events:update": "Aggiorna eventi",
            "fleet:events:delete": "Elimina eventi",
            "fleet:events:manage": "Gestisci eventi",
            "fleet:notifications:manage": "Gestisci impostazioni notifiche"
          },
          "name": "Nome",
          "rank": "Rango"
        },
        "inviteUrls": {
          "noExpiration": "Nessuna scadenza",
          "used": "Usato %{count} volte",
          "usedOfLimit": "%{count} di %{limit} utilizzati",
          "expiresIn": "Scade tra %{time}",
          "expired": "Scaduto",
          "expiresAfterOptions": {
            "infinite": "Mai",
            "30_minutes": "30 minuti",
            "1_hour": "1 ora",
            "6_hours": "6 ore",
            "12_hours": "12 ore",
            "1_day": "1 giorno",
            "7_days": "7 giorni"
          },
          "limitOptions": {
            "1": "1 uso",
            "5": "5 utilizzi",
            "10": "10 utilizzi",
            "25": "25 utilizzi",
            "50": "50 utilizzi",
            "100": "100 utilizzi",
            "infinite": "Nessun limite"
          }
        },
        "calendarSubscription": {
          "intro": "Genera un link privato che i membri possono usare per iscriversi agli eventi di questa flotta dalla loro app calendario (Apple Calendar, Google Calendar, Outlook).",
          "howTo": "Condividi il link qui sopra con i tuoi membri. Lo incollano nella loro app calendario (\"Iscriviti a un calendario\" o \"Aggiungi tramite URL\"). Il link è privato — chiunque lo possieda può vedere gli eventi di questa flotta."
        },
        "notifications": {
          "inAppHint": "Scegli quali cambiamenti di stato degli eventi appaiono come notifiche nell'app per i membri della flotta.",
          "events": {
            "fleet_event": {
              "published": "Evento pubblicato",
              "locked": "Iscrizioni bloccate",
              "unlocked": "Iscrizioni riaperte",
              "starting_soon": "Evento in partenza",
              "started": "Evento avviato",
              "completed": "Evento completato",
              "cancelled": "Evento annullato",
              "archived": "Evento archiviato",
              "destroyed": "Evento eliminato"
            },
            "fleet_event_signup": {
              "created": "Iscrizione aggiunta",
              "withdrawn": "Iscrizione ritirata"
            }
          }
        },
        "inventories": {
          "name": "Nome",
          "description": "Descrizione",
          "location": "Posizione",
          "visibility": "Visibilità",
          "manager": "Responsabile",
          "itemsCount": "Voci",
          "visibilities": {
            "members_only": "Solo membri",
            "officers_only": "Solo ufficiali"
          }
        }
      },
      "hangarGroup": {
        "name": "Nome",
        "color": "Colore",
        "sort": "Ordina per",
        "public": "Mostrare nell'Hangar pubblico?"
      },
      "source": "Fonte",
      "loadout": {
        "namePlaceholder": "Nome configurazione...",
        "urlPlaceholder": "Incolla l'URL della configurazione di erkul.games o spviewer.eu...",
        "empty": "Ancora nessuna configurazione. Creane una per iniziare.",
        "active": "Attiva",
        "activate": "Rendi attiva",
        "planOn": "Pianifica la tua configurazione su"
      },
      "model": {
        "hidden": "Nascosto?",
        "active": "Attivo?",
        "inGame": "Nel gioco?",
        "adiMap": "Mappa ADI?",
        "ground": "Veicolo terrestre?",
        "productionNote": "Nota di produzione",
        "rsiId": "RSI ID",
        "length": "Lunghezza",
        "beam": "Larghezza",
        "height": "Altezza",
        "scKey": "SC Key",
        "price": "Prezzo",
        "pledgePrice": "Prezzo Pledge",
        "erkulIdentifier": "Erkul Identifier",
        "mass": "Massa",
        "minCrew": "Equipaggio min.",
        "maxCrew": "Equipaggio max.",
        "storeUrl": "Store URL",
        "salesPageUrl": "Sales Page URL",
        "scmSpeed": "SCM Speed",
        "scmSpeedBoosted": "SCM Speed Boosted",
        "maxSpeed": "Velocità max.",
        "reverseSpeedBoosted": "Reverse Speed Boosted",
        "cargo": "Carico",
        "cargoHolds": "Stive di carico",
        "hydrogenFuelTankSize": "Dimensione serbatoio idrogeno",
        "hydrogenFuelTanks": "Serbatoi carburante idrogeno",
        "quantumFuelTankSize": "Dimensione serbatoio Quantum",
        "quantumFuelTanks": "Serbatoi carburante Quantum",
        "externalFuelTanks": "Serbatoi di carburante esterni",
        "externalFuelTanksTotal": "Capacità totale",
        "externalFuelTanksCount": "Pod",
        "refuelBoom": "Braccio di rifornimento",
        "refuelBoomArm": "Braccio",
        "refuelBoomNozzle": "Ugello",
        "yaw": "Yaw",
        "pitch": "Pitch",
        "roll": "Roll",
        "yawBoosted": "Imbardata potenziata",
        "pitchBoosted": "Beccheggio potenziato",
        "rollBoosted": "Rollio potenziato",
        "variants": "Varianti",
        "manufacturer": "Produttore",
        "loaners": "Navi in comodato",
        "paints": "Verniciature",
        "modules": "Moduli",
        "modulePackages": "Pacchetti Modulo",
        "upgrades": "Kit Di Potenziamento",
        "brochure": "Opuscolo",
        "holo": "Holo",
        "angledView": "Vista angolata",
        "angledViewColored": "Vista angolata a colori",
        "sideView": "Vista laterale",
        "sideViewColored": "Vista laterale a colori",
        "frontView": "Vista frontale",
        "frontViewColored": "Vista frontale a colori",
        "topView": "Vista dall'alto",
        "topViewColored": "Vista dall'alto a colori",
        "onSale": "In Vendita",
        "playerOwnable": "Acquistabile dai giocatori?",
        "salesPage": "Pagina Di Vendita",
        "addons": "Moduli E Kit Di Potenziamento",
        "storeImage": "Immagine negozio",
        "wiki": "Star Citizen Wiki",
        "crewPositions": "Postazioni dell'equipaggio",
        "needsCuration": "Richiede revisione",
        "curatedPosition": "Posizione curata manualmente",
        "baseModel": "Modello base",
        "fleetchartOffsetLength": "Offset lunghezza grafico flotta",
        "fleetchartOffsetBeam": "Offset larghezza grafico flotta",
        "extendedLength": "Lunghezza estesa",
        "extendedBeam": "Larghezza estesa",
        "extendedHeight": "Altezza estesa",
        "extendedFleetchartOffsetLength": "Offset lunghezza grafico flotta esteso",
        "extendedFleetchartOffsetBeam": "Offset larghezza grafico flotta esteso",
        "defaultHolo": "Holo predefinito",
        "extendedHolo": "Holo esteso",
        "extendedTopView": "Vista dall'alto estesa",
        "extendedTopViewColored": "Vista dall'alto estesa a colori",
        "extendedSideView": "Vista laterale estesa",
        "extendedSideViewColored": "Vista laterale estesa a colori",
        "extendedFrontView": "Vista frontale estesa",
        "extendedFrontViewColored": "Vista frontale estesa a colori",
        "extendedAngledView": "Vista angolata estesa",
        "extendedAngledViewColored": "Vista angolata estesa a colori",
        "state": {
          "retracted": "Retratta",
          "extended": "Estesa"
        },
        "productionStatus": {
          "in-production": "In Produzione",
          "in-concept": "In fase di progettazione",
          "ready": "Pronto per l'hangar",
          "flight-ready": "Pronto al volo",
          "announced": "Annunciato"
        },
        "scIdentifier": "SC Identifier"
      },
      "models": {
        "extraColumns": "Colonne",
        "table": {
          "columns": {
            "storeImage": "Immagine",
            "storeImageWide": "Immagine larga",
            "rsiStoreImage": "Immagine RSI",
            "rsiStoreImageWide": "Immagine RSI larga",
            "angledView": "Immagine 3D",
            "angledViewWide": "Immagine 3D larga",
            "rsiId": "RSI ID",
            "hidden": "Nascosto",
            "active": "Attivo",
            "createdAt": "Creato il",
            "updatedAt": "Aggiornato il",
            "manufacturerName": "Produttore",
            "length": "Lunghezza",
            "beam": "Larghezza",
            "height": "Altezza",
            "mass": "Massa",
            "cargo": "Carico",
            "quantumFuelTankSize": "Carburante Quantum",
            "hydrogenFuelTankSize": "Carburante idrogeno",
            "minCrew": "Equipaggio",
            "maxCrew": "Equipaggio max.",
            "scmSpeed": "SCM Speed",
            "maxSpeed": "Velocità max.",
            "groundMaxSpeed": "Velocità a terra",
            "focus": "Specializzazione",
            "productionStatus": "Stato di produzione",
            "price": "Prezzo",
            "pledgePrice": "Prezzo Pledge"
          }
        }
      },
      "metrics": {
        "info": "Info",
        "levels": "Livelli",
        "views": "Visualizzazioni",
        "base": "Base",
        "crew": "Equipaggio",
        "speed": "Velocità",
        "cargo": "Carico",
        "combat": "Combattimento",
        "hardpoints": "Punti di montaggio",
        "topView": "Vista dall'Alto"
      },
      "flight": {
        "title": "Volo",
        "scm": "crociera da combattimento",
        "nav": "crociera",
        "boost": "Boost",
        "boostSub": "postbruciatore",
        "reverse": "Retromarcia",
        "maneuverability": "Manovrabilità",
        "fuel": "Carburante",
        "fuelHydrogen": "Idrogeno",
        "fuelQuantum": "Quantum",
        "hint": "La manovrabilità potenziata dipende dai pips del motore; tutto a zero quando il motore non è alimentato."
      },
      "base": {
        "price": "Prezzo",
        "priceInGame": "In-game",
        "pricePledge": "Pledge",
        "availability": "Disponibilità"
      },
      "availability": {
        "title": "Disponibilità",
        "buy": "Acquisto",
        "rent": "Noleggio",
        "cheapest": {
          "buy": "Acquisto più economico",
          "rent": "Noleggio più economico"
        },
        "locations": {
          "one": "%{count} posizione",
          "other": "%{count} posizioni"
        },
        "empty": "Nessuna posizione di acquisto o noleggio conosciuta.",
        "timeRange": {
          "1-day": "1 giorno",
          "3-days": "3 giorni",
          "7-days": "7 giorni",
          "30-days": "30 giorni"
        }
      },
      "cargo": {
        "title": "Carico",
        "holdsSub": "su %{count} stive",
        "maxContainerSub": "il container più grande che ci sta",
        "containers": "Capacità in container",
        "hint": "Numero massimo di container di ciascuna dimensione che entrano nelle griglie di carico; la barra mostra quanta parte della capacità totale occupano."
      },
      "fuelTanks": {
        "capacitySub": "su %{count} pod",
        "podsSub": "attacchi esterni",
        "components": "Tipi di pod",
        "perPod": "per pod",
        "hint": "Carburante trasportato in pod montati su punti di montaggio esterni; la barra mostra la quota di ciascun tipo sulla capacità totale."
      },
      "refuelBoom": {
        "fuelFlowSub": "trasferimento idrogeno",
        "quantumFlowSub": "trasferimento quantum",
        "captureRadiusSub": "tolleranza di aggancio",
        "equipment": "Equipaggiamento",
        "hint": "Velocità di trasferimento del braccio di rifornimento e tolleranza di aggancio del suo ugello."
      },
      "combat": {
        "title": "Combattimento",
        "dps": "DPS di raffica",
        "dpsSub": "%{count} armi",
        "sustained": "DPS sostenuto",
        "sustainedSub": "con regen e calore",
        "alpha": "Alpha",
        "alphaSub": "per salva",
        "weapons": "Armi",
        "missileDamage": "Danno dei missili",
        "composition": "Composizione del danno",
        "damagePhysical": "Fisico",
        "damageEnergy": "Energia",
        "damageDistortion": "Distorsione",
        "damageThermal": "Termico",
        "hint": "DPS della configurazione predefinita. Il valore sostenuto tiene conto della rigenerazione della riserva energetica di ogni arma e del ciclo di surriscaldamento. Missili esclusi."
      },
      "power": {
        "title": "Distribuzione dell'energia",
        "scm": "SCM",
        "nav": "NAV",
        "reset": "Reimposta",
        "auto": "Auto",
        "aimAssist": "Assistenza alla mira",
        "cooling": "Raffreddamento",
        "ir": "IR",
        "em": "EM",
        "cs": "CS",
        "csAxisHint": "Clicca per cambiare asse (x / y / z)",
        "segmentsUsed": "%{used} / %{total} segmenti",
        "hint": "Sposta l'energia tra i sistemi. Il DPS sostenuto delle armi dipende dall'energia che ricevono; il resto viene bilanciato automaticamente.",
        "families": {
          "weapon": "Armi",
          "shield": "Scudi",
          "engine": "Motore",
          "radar": "Radar",
          "coolers": "Refrigeranti",
          "qdrive": "Motore Quantum",
          "qed": "QED",
          "emp": "EMP",
          "lifeSupport": "Supporto vitale",
          "miningLaser": "Laser da estrazione",
          "salvage": "Recupero",
          "tractorBeam": "Raggio traente",
          "towingbeam": "Raggio di traino"
        }
      },
      "defense": {
        "title": "Difesa",
        "shieldHp": "HP scudi",
        "shieldHpSub": "%{count} generatori",
        "shieldRegen": "Rigenerazione",
        "shieldResistances": "Resistenza",
        "shieldAbsorption": "Assorbimento",
        "armor": "Corazza",
        "deflection": "Deflessione",
        "armorReduction": "Riduzione del danno",
        "armorSelfResistance": "Autoresistenza",
        "armorSignature": "Firma",
        "damageType": {
          "physical": "Fis.",
          "energy": "Energia",
          "distortion": "Distors.",
          "thermal": "Termico"
        },
        "signature": {
          "electromagnetic": "EM",
          "infrared": "IR",
          "crossSection": "CS"
        },
        "hint": "Valori di scudi e corazza della configurazione predefinita. Un assorbimento inferiore al 100% significa che quel tipo di danno raggiunge lo scafo mentre gli scudi sono ancora attivi.",
        "openDeflectionCheck": "Verifica deflessione"
      },
      "deflectionCheck": {
        "title": "Verifica della deflessione",
        "intro": "— quali armi perforano le sue difese?",
        "noArmor": "Questa nave non ha corazza, quindi non viene deflesso nulla.",
        "allSizes": "Tutte",
        "deflected": "deflessi",
        "pierce": "perforano",
        "weapon": "Arma",
        "boundary": "Soglia di deflessione",
        "alpha": "Alpha",
        "threshold": "Soglia superata",
        "absorbed": "assorbiti",
        "versus": "contro",
        "hoverHint": "Passa il mouse su un'arma per il dettaglio per tipo di danno.",
        "note": "L'alpha viene confrontato per singolo proiettile, dopo l'assorbimento dello scudo — un'arma perfora quando supera la deflessione su almeno un tipo di danno. I tipi che gli scudi assorbono completamente non raggiungono mai la corazza, perciò sono indicati come assorbiti anziché deflessi: fermati dallo scudo, non dallo scafo. L'assorbimento dello scudo viene interpolato nell'intervallo min-max dichiarato in base alla salute dello scudo, e la deflessione della corazza scala linearmente con la salute della corazza. I raggi laser sono esclusi: infliggono danno continuo, quindi non c'è un alpha per colpo da verificare.",
        "margin": "Margine",
        "reachesArmor": "Raggiunge la corazza",
        "stoppedByShields": "Assorbito dallo scudo",
        "verdict": {
          "absorbed": "Assorbito",
          "deflected": "Deflesso",
          "pierces": "Perforato"
        },
        "shieldHealth": "Salute scudi",
        "armorHealth": "Salute corazza",
        "absorb": "Assorb.",
        "defl": "Defl.",
        "type": "Tipo",
        "size": "Dimensione"
      },
      "hull": {
        "category": {
          "vital": "Vitali",
          "secondary": "Secondarie",
          "breakable": "Distruttibili",
          "subpart": "Sottoparti",
          "cosmetic": "Estetiche"
        },
        "composition": "Composizione dello scafo",
        "door": "Porta",
        "doors": "Porte",
        "doorsNote": "Le porte interne distruttibili sono un'area a sé — hanno una salute propria e non fanno parte degli HP dello scafo.",
        "doorsSub": "%{count} distruttibili",
        "hint": "Gli HP dello scafo sono la somma della salute di tutte le parti.",
        "hullHp": "HP scafo",
        "hullHpSub": "totale su tutte le parti",
        "integrity": "Integrità dello scafo",
        "noHp": "nessun HP",
        "parts": "Parti dello scafo",
        "partsNote": "Le parti sono ordinate per salute; le parti estetiche (porte, scale, portelli) non hanno una salute propria. I file di gioco non espongono alcun legame padre/figlio, quindi questo è un elenco piatto e non un albero strutturale.",
        "partsSub": "su %{count} categorie",
        "partsTree": "Parti · damageMax",
        "showParts": "Mostra le parti dello scafo",
        "title": "Scafo",
        "totalHp": "HP scafo totali"
      },
      "manufacturer": {
        "longName": "Nome completo",
        "code": "Codice",
        "logo": "Logo",
        "logoOverridden": "Logo (sovrascritto)",
        "icon": "Icona (file di gioco)",
        "iconOverridden": "Icona (sovrascritta)",
        "scRef": "SC Ref"
      },
      "fundingGoal": {
        "title": "Titolo",
        "description": "Descrizione",
        "amount": "Importo",
        "currency": "Valuta",
        "effectiveFrom": "In vigore dal",
        "endedAt": "Terminato il"
      },
      "supporterContribution": {
        "name": "Nome del sostenitore",
        "user": "Account collegato",
        "amount": "Importo",
        "currency": "Valuta",
        "anonymous": "Anonimo",
        "recurring": "Ricorrente",
        "startedAt": "Iniziato il",
        "endedAt": "Terminato il",
        "note": "Nota interna",
        "stats": {
          "total": "Totale",
          "count": "Contributi",
          "currentMonth": "Questo mese",
          "currentMonthCount": "%{count} contributi",
          "recurringCount": "Ricorrenti",
          "anonymousCount": "Anonimi"
        },
        "chart": {
          "contributions": "Contributi",
          "goal": "Obiettivo"
        }
      },
      "itemPrice": {
        "price": "Prezzo",
        "location": "Posizione",
        "locationUrl": "URL posizione"
      },
      "video": {
        "url": "URL",
        "videoType": "Tipo"
      },
      "modelModule": {
        "name": "Nome",
        "description": "Descrizione",
        "price": "Prezzo",
        "pledgePrice": "Prezzo Pledge",
        "productionStatus": "Stato di Produzione",
        "scKey": "SC Key",
        "storeImage": "Immagine Negozio",
        "active": "Attivo?",
        "hidden": "Nascosto?"
      },
      "dock": {
        "name": "Nome",
        "dockType": "Tipo di dock",
        "shipSize": "Dimensione nave"
      },
      "modelPosition": {
        "name": "Nome",
        "positionType": "Tipo di posizione",
        "source": "Fonte",
        "position": "Ordinamento",
        "types": {
          "pilot": "Pilota",
          "copilot": "Copilota",
          "turret_gunner": "Artigliere di torretta",
          "engineer": "Ingegnere",
          "gunner": "Artigliere",
          "loadmaster": "Responsabile del carico",
          "passenger": "Passeggero",
          "operator": "Operatore",
          "custom": "Personalizzata"
        }
      },
      "modelUpgrade": {
        "name": "Nome",
        "description": "Descrizione",
        "pledgePrice": "Prezzo Pledge",
        "active": "Attivo?",
        "hidden": "Nascosto?"
      },
      "modelModulePackage": {
        "name": "Nome",
        "description": "Descrizione",
        "pledgePrice": "Prezzo Pledge",
        "modules": "Moduli",
        "active": "Attivo?",
        "hidden": "Nascosto?"
      },
      "cargoHold": {
        "offsetX": "Offset X (SCU)",
        "offsetY": "Offset Y (SCU)",
        "offsetZ": "Offset Z (SCU)",
        "rotation": "Rotazione (°)"
      },
      "modelLoaner": {
        "hidden": "Nascosto?",
        "loanerModel": "Modello in prestito"
      },
      "modelSnubCraft": {
        "snubCraft": "Snub Craft"
      },
      "modelPaint": {
        "hidden": "Nascosto?",
        "active": "Attivo?",
        "onSale": "In vendita",
        "pledgePrice": "Prezzo Pledge",
        "productionStatus": "Stato di produzione",
        "productionNote": "Nota di produzione",
        "copyHint": "Seleziona la nave di destinazione su cui copiare questa verniciatura. I dati della verniciatura non vengono modificati durante la copia.",
        "bulkCopyHint": "Seleziona la nave di destinazione su cui copiare queste %{count} verniciature. I dati delle verniciature non vengono modificati durante la copia.",
        "copySameModel": "La nave di destinazione deve essere diversa da quella di origine."
      },
      "component": {
        "size": "Dimensione: %{size}",
        "grade": "Grado",
        "hidden": "Nascosto?",
        "componentClass": "Classe componente",
        "componentType": "Tipo componente",
        "componentSubType": "Sottotipo componente",
        "itemType": "Tipo di oggetto",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "hardpoint": {
        "legend": {
          "headline": "Legenda",
          "slotTaken": "Slot preso",
          "slotAvailable": "Slot libero"
        },
        "size": "Dimensione",
        "rackSize": "Dimensione Rack",
        "details": "Dettagli",
        "group": "Gruppo",
        "thrusters": {
          "thrust": "Spinta",
          "subTypes": {
            "JointThruster": "Joint",
            "FixedThruster": "Fix",
            "FlexThruster": "Flex",
            "Retro": "Fix"
          }
        },
        "refuelBoom": {
          "captureRadius": "Raggio di aggancio",
          "fuelFlowRate": "Portata carburante",
          "quantumFuelFlowRate": "Portata carburante Quantum"
        },
        "weapons": {
          "dps": "DPS",
          "burstDps": "DPS di raffica",
          "sustainedDps": "DPS sostenuto",
          "efficiency": "Efficienza",
          "penetration": "Penetrazione",
          "fireRate": "Cadenza di fuoco",
          "speed": "Velocità",
          "range": "Gittata",
          "ammo": "Munizioni",
          "ammoCost": "Costo munizioni",
          "pool": "Riserva energetica",
          "maxRegen": "Regen max/s",
          "costPerShot": "Energia/colpo",
          "heatPerShot": "Calore/colpo",
          "heatPerSecond": "Calore/s",
          "chargeTime": "Tempo di carica",
          "fullDamageRange": "Gittata DMG pieno",
          "zeroDamageRange": "Gittata DMG nullo",
          "damagePhysical": "Fisico",
          "damageEnergy": "Energia",
          "damageDistortion": "Distorsione",
          "damageThermal": "Termico"
        },
        "missiles": {
          "damage": "Danno",
          "speed": "Velocità",
          "range": "Gittata",
          "lockRange": "Gittata di aggancio",
          "lockTime": "Tempo di aggancio",
          "trackingSignal": "Tracciamento"
        },
        "tractorBeams": {
          "maxForce": "Forza max",
          "minForce": "Forza min",
          "range": "Gittata",
          "cone": "Cono",
          "tetherBreak": "Rottura del vincolo",
          "cargoForce": "Forza sul carico",
          "cargoRange": "Gittata sul carico",
          "towForce": "Forza di traino",
          "towDistance": "Gittata di traino",
          "quantumTowMass": "Limite massa QT",
          "rotationSpeed": "Rotazione",
          "moveSpeed": "Velocità di spostamento"
        },
        "shields": {
          "hp": "HP",
          "regen": "Regen",
          "regenTime": "Tempo di regen",
          "downedRegenDelay": "Ritardo da abbattuto",
          "damagedRegenDelay": "Ritardo da danneggiato",
          "resistancePhysical": "Res. fis.",
          "resistanceEnergy": "Res. energia",
          "resistanceDistortion": "Res. distors."
        },
        "coolers": {
          "coolingRate": "Raffreddamento"
        },
        "powerPlants": {
          "output": "Output",
          "pips": "Pips"
        },
        "quantumDrives": {
          "speed": "Velocità",
          "range": "Autonomia",
          "fuelConsumption": "Consumo",
          "spoolUpTime": "Preparazione",
          "cooldownTime": "Recupero",
          "splineSpeed": "Orbita",
          "accel": "Accel."
        },
        "jumpDrives": {
          "fuelEfficiency": "Efficienza carburante",
          "alignRate": "Vel. allineamento",
          "tuneRate": "Vel. sintonizzazione",
          "alignDecay": "Decadimento allineamento",
          "tuneDecay": "Decadimento sintonizzazione"
        },
        "radar": {
          "aimAssistRange": "Gittata assistenza",
          "ir": "IR",
          "em": "EM",
          "cs": "CS",
          "rs": "RS"
        },
        "armor": {
          "hp": "HP",
          "physical": "Fisico",
          "energy": "Energia",
          "distortion": "Distorsione",
          "thermal": "Termico",
          "deflectPhysical": "Defl. fisico",
          "deflectEnergy": "Defl. energia",
          "selfPhysical": "Autores. fis.",
          "selfEnergy": "Autores. energia"
        },
        "fuelIntakes": {
          "pushRate": "Portata di spinta",
          "minRate": "Portata min."
        },
        "sources": {
          "game_files": "File di gioco",
          "ship_matrix": "Ship Matrix"
        },
        "density": {
          "title": "Vista",
          "compact": "Compatta",
          "expanded": "Estesa"
        },
        "fuelTanks": {
          "hydrogen": "Serbatoio carburante idrogeno",
          "quantum": "Serbatoio carburante Quantum"
        },
        "jumpDrive": "Motore di salto",
        "maxContainerSize": "Dimensione max. container",
        "groups": {
          "avionic": "Avionica",
          "system": "Sistema",
          "propulsion": "Propulsione",
          "thruster": "Propulsori",
          "weapon": "Armamenti",
          "defense": "Difesa",
          "other": "Altro",
          "auxiliary": "Ausiliario",
          "seat": "Sedili",
          "external_fuel_tank": "Serbatoi di carburante esterni",
          "refuel_boom": "Braccio di rifornimento"
        },
        "types": {
          "radar": "Radar",
          "computers": "Computer",
          "power_plants": "Generatori",
          "coolers": "Refrigeranti",
          "shield_generators": "Generatori di Scudi",
          "fuel_intakes": "Bocchettoni carburante",
          "fuel_tanks": "Serbatoi Carburante",
          "quantum_drives": "Drive Quantici",
          "jump_modules": "Moduli di salto",
          "jumpdrive": "Moduli di salto",
          "quantum_fuel_tanks": "Serbatoi di Carburante Quantico",
          "main_thrusters": "Propulsori Principali",
          "maneuvering_thrusters": "Propulsori di Manovra",
          "weapons": "Armamenti",
          "turrets": "Torrette",
          "missiles": "Missili",
          "utility_items": "Oggetti di utilità",
          "utility": "Oggetti di utilità",
          "emp": "EMP",
          "qed": "QED"
        },
        "moduleSlotEmpty": "— Seleziona modulo —",
        "selectModule": "Seleziona modulo",
        "moduleStock": "Come consegnato",
        "moduleStockHint": "Slot lasciato come arriva la nave",
        "categories": {
          "radar": "Radar",
          "armor": "Corazza",
          "relay": "Relè",
          "countermeasures": "Contromisure",
          "lifesupport": "Supporto vitale",
          "selfdestruct": "Autodistruzione",
          "batteries": "Batterie",
          "computers": "Computer",
          "powerplant": "Centrali energetiche",
          "cooler": "Raffreddatori",
          "module": "Moduli",
          "shieldgenerator": "Generatori di scudi",
          "fuel_intakes": "Prese di carburante",
          "fueltanks": "Serbatoi di carburante",
          "external_fuel_tanks": "Serbatoi di carburante esterni",
          "refuel_boom": "Braccio di rifornimento",
          "quantumdrive": "Motori Quantum e moduli di salto",
          "jump_modules": "Moduli di salto",
          "jumpdrive": "Moduli di salto",
          "quantum_fuel_tanks": "Serbatoi carburante Quantum",
          "main_thrusters": "Propulsori principali",
          "maneuvering_thrusters": "Propulsori di manovra",
          "retro_thrusters": "Propulsori retro",
          "vtol_thrusters": "Propulsori VTOL",
          "weapons": "Armi",
          "weapon_mounts": "Supporti armi",
          "turret": "Torrette",
          "missiles": "Missili",
          "missile_racks": "Rack missili",
          "utility_items": "Oggetti di utilità",
          "utility": "Oggetti di utilità",
          "emp": "EMP",
          "quantumenforcementdevice": "QED",
          "salvagefillerstation": "Stazione di riempimento salvataggio",
          "cargogrid": "Griglia di carico",
          "seat": "Sedili"
        }
      },
      "blank": {
        "propulsion": "Nessun Propulsione presente",
        "modular": "Nessun modulare presente",
        "fleetInvites": "Nessun Invito presente"
      },
      "user": {
        "rsiHandle": "Handle",
        "rsiHandleVerified": "Verificato tramite Citizen iD",
        "location": "Posizione",
        "currentSystem": "Sistema stellare attuale",
        "tester": "Tester?",
        "avatar": "Avatar",
        "unconfirmedEmail": "Email non confermata",
        "saleNotify": "Voglio ricevere notifiche di vendita",
        "publicHangar": "Hangar Pubblico abilitato",
        "publicHangarLoaners": "Mostra suggerimento Navi di Cortesia su Hangar Pubblico",
        "publicHangarStats": "Statistiche hangar pubbliche abilitate",
        "publicWishlist": "Lista dei desideri pubblica abilitata",
        "hideOwner": "Nascondi proprietà per le flotte",
        "tracking": "Consenti analisi di utilizzo anonime",
        "lastActiveAt": "Ultima attività",
        "confirmedAt": "Confermato il",
        "dateFormat": "Formato data",
        "dateFormats": {
          "dmy_dots": "31.12.2026",
          "dmy_slash": "31/12/2026",
          "mdy_slash": "12/31/2026",
          "ymd_dash": "2026-12-31"
        }
      },
      "adminUser": {
        "superAdmin": "Super admin",
        "passwordConfirmation": "Conferma password"
      },
      "vehicle": {
        "name": "Nome",
        "states": "Stati",
        "serial": "Seriale",
        "owner": "comandata da",
        "flagship": "Ammiraglia",
        "wanted": "Desiderato",
        "loaner": "Prestito",
        "bundled": "In bundle",
        "bundledWith": "In bundle con %{parent}",
        "public": "Pubblicamente Visibile",
        "fullPublic": "Pubblicamente Visibile incluso il nome",
        "publicShort": "Pubblico",
        "nameVisible": "Pubblicamente Visibile",
        "saleNotify": "Voglio ricevere notifiche di messa in vendita",
        "hangarGroups": "Gruppi",
        "modelPaintSelect": {
          "nullablePrompt": "Seleziona una Paint",
          "label": "Verniciatura"
        },
        "bulkGroupEdit": {
          "hint": "I Gruppi esistenti saranno sovrascritti!"
        },
        "hasLoaners": "Navi in comodato",
        "boughtViaSelect": {
          "label": "Acquistato tramite"
        }
      },
      "image": {
        "active": "Attivo?",
        "background": "Utilizzare come background?",
        "caption": "Didascalia",
        "enabled": "Abilitato?",
        "file": "File immagine",
        "global": "Globale?",
        "delete": "Elimina",
        "start": "Avvia",
        "cancel": "Annulla",
        "processing": "Elaborazione...",
        "error": "Errore",
        "name": "Nome",
        "size": "Dimensione file",
        "dropzone": "Trascina qui le immagini",
        "cancelUpload": "Annulla il caricamento",
        "startUpload": "Avvia caricamento",
        "selectImages": "Aggiungi immagini...",
        "selectFolder": "Aggiungi una cartella..."
      },
      "signup": {
        "link": "Non hai un Account?",
        "privacyPolicy": "Creando un account FleetYards, accetti la nostra"
      },
      "privacyPolicy": "Informativa sulla privacy",
      "login": "Username o e-mail",
      "username": "Nome utente",
      "twoFactorCode": "Codice due-fattori",
      "confirmationCode": "Codice di conferma",
      "email": "E-mail",
      "avatar": "Avatar",
      "alreadyRegistered": "Hai già un account?",
      "password": "Password",
      "passwordConfirmation": "Conferma Password",
      "rememberMe": "Resta Collegato",
      "emptyList": "Nessun %{name} presente",
      "all": "Tutto",
      "supportUs": "Supporta FleetYards.net",
      "account": {
        "destroyInfo": "Se si desidera eliminare il tuo account e rimuovere tutte le informazioni da Fleetyards,nett e i suoi servizi fare clic sul pulsante qui sotto. Sii consapevole che questa è un'azione permanente e non può essere annullata.",
        "calendarSubscription": {
          "intro": "Genera un link privato per aggiungere gli eventi a cui ti sei iscritto alla tua app calendario personale (Apple Calendar, Google Calendar, Outlook).",
          "howTo": "Incolla il link nella tua app calendario sotto \"Iscriviti a un calendario\" o \"Aggiungi tramite URL\". Chiunque abbia questo link può vedere gli eventi a cui ti sei iscritto — tienilo privato."
        }
      },
      "filters": {
        "components": {
          "name": "Nome",
          "itemType": "Tipo di oggetto",
          "componentClass": "Classe componente",
          "buyPriceGt": "Prezzo d'acquisto >=",
          "buyPriceLt": "Prezzo d'acquisto <=",
          "sellPriceGt": "Prezzo di vendita >=",
          "sellPriceLt": "Prezzo di vendita <=",
          "storeImageBlank": "Senza immagine negozio?"
        },
        "shops": {
          "name": "Nome",
          "type": "Tipo",
          "model": "Nave",
          "equipment": "Equipaggiamento",
          "component": "Componente",
          "commodity": "Prodotto",
          "commodityType": "Tipo Di Prodotto"
        },
        "shopCommodities": {
          "commodityType": "Tipo Di Prodotto",
          "equipment": "Equipaggiamento",
          "component": "Componente",
          "commodity": "Prodotto",
          "model": "Nave",
          "name": "Nome"
        },
        "shopItems": {
          "category": "Categoria",
          "subCategory": "Sottocategoria",
          "name": "Nome",
          "manufacturer": "Produttore"
        },
        "stations": {
          "name": "Nome",
          "type": "Tipo di Stazione",
          "shops": "Negozi",
          "docks": "Moli"
        },
        "vehicles": {
          "name": "Nome o nome della Nave",
          "lengthLt": "Lunghezza <=",
          "lengthGt": "Lunghezza >=",
          "pledgePriceLt": "Prezzo del Pledge <=",
          "pledgePriceGt": "Prezzo del Pledge >=",
          "priceLt": "Prezzo <=",
          "priceGt": "Prezzo >=",
          "wanted": "Desiderato",
          "hidden": "Nascosto",
          "public": "Pubblico",
          "group": "Gruppo",
          "loaner": "Navi in comodato",
          "bundled": "Snub Craft in bundle",
          "boughtVia": "Acquistato tramite?"
        },
        "tradeRoutes": {
          "sortBy": "Ordina per",
          "sortByValues": {
            "percent": "Percentuale Max."
          },
          "origin": "Da?",
          "destination": "A?"
        },
        "models": {
          "name": "Nome",
          "classification": "Classificazione",
          "focus": "Specializzazione",
          "manufacturer": "Produttore",
          "onSale": "In Vendita",
          "size": "Dimensione",
          "dockSize": "Dimensione dock",
          "price": "Prezzo",
          "pledgePrice": "Prezzo del Pledge",
          "productionStatus": "Stato Della Produzione",
          "lengthLt": "Lunghezza <=",
          "lengthGt": "Lunghezza >=",
          "beamLt": "Raggio <=",
          "beamGt": "Raggio >=",
          "heightLt": "Altezza <=",
          "heightGt": "Altezza >=",
          "pledgePriceLt": "Prezzo del Pledge <=",
          "pledgePriceGt": "Prezzo del Pledge >=",
          "priceLt": "Prezzo <=",
          "priceGt": "Prezzo >=",
          "willItFit": "Ci starà?",
          "withCargo": "Con carico?",
          "scKeyBlank": "Senza SC Key?",
          "positionsNeedCuration": "Posizioni da revisionare?",
          "fleetchartImageBlank": "Senza immagine grafico flotta?",
          "holoBlank": "Senza Holo?",
          "frontViewBlank": "Senza immagine vista frontale?",
          "topViewColoredBlank": "Senza immagine vista dall'alto a colori?",
          "scIdentifierBlank": "Senza identificatore SC?"
        },
        "modelModules": {
          "name": "Nome"
        },
        "manufacturers": {
          "name": "Nome",
          "withModels": "Con modelli",
          "logoBlank": "Senza logo"
        },
        "supporterContributions": {
          "name": "Cerca per nome",
          "recurring": "Ricorrente",
          "anonymous": "Anonimo",
          "startedAtGteq": "Iniziato dal",
          "startedAtLteq": "Iniziato fino al",
          "user": "Account collegato",
          "linked": "Collegamento account",
          "linkedOnly": "Collegato",
          "unlinkedOnly": "Non collegato"
        },
        "adminNotifications": {
          "search": "Cerca"
        },
        "images": {
          "model": "Nave"
        },
        "users": {
          "search": "Cerca",
          "username": "Nome utente",
          "email": "E-mail",
          "rsiHandle": "Handle RSI"
        },
        "fleets": {
          "name": "Nome",
          "fid": "FID",
          "member": "Membro",
          "members": {
            "role": "Ruolo",
            "state": "Stato",
            "acceptedAtGt": "Iscritto dal",
            "acceptedAtLt": "Iscritto fino al",
            "invitedAtGt": "Invitato dal",
            "invitedAtLt": "Invitato fino al",
            "requestedAtGt": "Richiesto dal",
            "requestedAtLt": "Richiesto fino al",
            "declinedAtGt": "Rifiutato dal",
            "declinedAtLt": "Rifiutato fino al"
          },
          "inviteUrls": {
            "expiresAfter": "Scade dopo",
            "limit": "Numero massimo di utilizzi"
          },
          "logistics": {
            "search": "Cerca oggetti..."
          }
        },
        "manufacturer": "Produttore",
        "commodities": {
          "name": "Name",
          "commodityType": "Commodity Type",
          "uexCode": "UEX Code",
          "buyPriceGt": "Prezzo d'acquisto >=",
          "buyPriceLt": "Prezzo d'acquisto <=",
          "sellPriceGt": "Prezzo di vendita >=",
          "sellPriceLt": "Prezzo di vendita <=",
          "storeImageBlank": "Senza immagine negozio?"
        },
        "equipment": {
          "name": "Name",
          "equipmentType": "Equipment Type",
          "itemType": "Item Type",
          "weaponClass": "Weapon Class",
          "slot": "Slot",
          "buyPriceGt": "Prezzo d'acquisto >=",
          "buyPriceLt": "Prezzo d'acquisto <=",
          "sellPriceGt": "Prezzo di vendita >=",
          "sellPriceLt": "Prezzo di vendita <=",
          "storeImageBlank": "Senza immagine negozio?"
        },
        "notifications": {
          "search": "Cerca"
        }
      },
      "station": {
        "docks": "Moli",
        "location": "Posizione",
        "type": "Tipo",
        "shops": "Negozi",
        "locationPrefix": {
          "default": "su",
          "orbit": "in orbita attorno"
        }
      },
      "tradeRoutes": {
        "buy": "Acquista per: %{uec}",
        "sell": "Vendi per: %{uec}"
      },
      "hardpoints": {
        "prefix": "Prova le configurazioni con",
        "erkul": "Erkul's DPS Calculator",
        "spviewer": "SP Viewer",
        "spviewerTitle": "SC Ships Performances Viewer",
        "metricsCredit": "Metriche basate sulle formule di"
      },
      "scunpacked": {
        "prefix": "Loadouts basato sui Gamefiles powered by",
        "link": "SCunpacked"
      },
      "newVehicle": {
        "nullablePrompt": "Seleziona una Nave"
      },
      "table": {
        "selected": "%{count} selezionati"
      },
      "commodityPrice": {
        "item": "ShopCommodity",
        "price": "Prezzo",
        "type": "Tipo",
        "shop": "Negozio"
      },
      "syncExtension": {
        "warnings": "Avvisi",
        "status": {
          "started": "Importazione avviata...",
          "finished": "Importazione completata",
          "failed": "Importazione fallita!"
        },
        "processSteps": {
          "fetchHangar": "Recupero dati dall'hangar RSI",
          "submitData": "Invio dati al backend di Fleetyards.net"
        },
        "sessionStatus": "Stato sessione RSI",
        "checkIdentity": "Verifica sessione RSI",
        "identityStatus": {
          "pending": "Verifica...",
          "notFound": "non trovato",
          "connected": "connesso"
        },
        "platforms": {
          "chrome": "Google Chrome",
          "firefox": "Mozilla Firefox",
          "edge": "Microsoft Edge",
          "opera": "Opera",
          "github": "GitHub"
        },
        "pledgeItems": {
          "pages": "Pagine",
          "all": "Tutti gli oggetti Pledge",
          "ships": "Navi",
          "components": "Moduli",
          "upgrades": "Upgrade"
        },
        "importedItems": {
          "importedVehicles": "Navi aggiunte",
          "foundVehicles": "Navi trovate",
          "movedVehiclesToWanted": "Navi spostate nella lista dei desideri",
          "missingModels": "Navi non trovate",
          "importedComponents": "Componenti aggiunti",
          "foundComponents": "Componenti trovati",
          "missingComponents": "Componenti non trovati",
          "missingComponentVehicles": "Nessuna nave corrispondente trovata per i componenti",
          "importedUpgrades": "Upgrade aggiunti",
          "foundUpgrades": "Upgrade trovati",
          "missingUpgrades": "Upgrade non trovati",
          "missingUpgradeVehicles": "Nessuna nave corrispondente trovata per gli upgrade",
          "new": "New",
          "updated": "Updated",
          "movedToWanted": "Moved to Wishlist",
          "missing": "Unable to Import"
        }
      },
      "cargoGridViewer": {
        "capacity": "Capacità",
        "maxContainerSize": "Container max.",
        "packed": "Impacchettato",
        "totalCargo": "Carico totale",
        "didNotFit": "Non entra",
        "enoughShips": "Quattro navi riempiono la griglia.",
        "addShip": "Aggiungi nave",
        "removeShip": "Remove",
        "autoFillShip": "Auto-fill"
      },
      "travelTimes": {
        "quantumDrive": "Motore Quantum",
        "fuelUsage": "Consumo di carburante",
        "travelTime": "Tempo di viaggio",
        "poweredBy": "basato su",
        "rank": "#",
        "size": "Dimensione",
        "grade": "Grado",
        "sizeValue": "S%{size}",
        "intro": "Quanto impiega ogni motore Quantum per il tuo salto — e quanto carburante Quantum consuma.",
        "jumpDistance": "Distanza di salto",
        "distanceHint": "1 Mkm è un milione di chilometri. Attraversare Stanton ne richiede circa 40.",
        "filters": "Filtri",
        "resetFilters": "Reimposta",
        "barLegend": "La barra mostra il tempo rispetto al motore più lento",
        "count": "%{count} motori",
        "countFiltered": "%{count} di %{total} motori",
        "noMatch": "Nessun motore corrisponde a questi filtri.",
        "presets": {
          "moon": "Salto lunare",
          "short": "Salto breve",
          "system": "Attraverso Stanton",
          "far": "Lunga tratta"
        }
      },
      "admin": {
        "dashboard": {
          "quickStats": {
            "onlineUsers": "Utenti online",
            "totalUsers": "Utenti totali",
            "totalShips": "Navi totali",
            "newShipsInYear": "Nuove navi nel %{year}",
            "totalFleets": "Flotte totali"
          }
        },
        "supporterContributions": {
          "source": {
            "patreon": "Patreon",
            "manual": "Manuale"
          }
        },
        "resourceAccess": {
          "title": "Accesso alle risorse",
          "groups": {
            "ship_data": "Dati delle navi",
            "community": "Community",
            "system": "Sistema"
          },
          "privileges": {
            "models": "Modelli",
            "model_modules": "Moduli dei modelli",
            "components": "Componenti",
            "manufacturers": "Produttori",
            "vehicles": "Veicoli",
            "images": "Immagini",
            "fleets": "Flotte",
            "users": "Utenti",
            "supporters": "Sostenitori",
            "admins": "Admin",
            "oauth_applications": "Applicazioni OAuth",
            "maintenance": "Manutenzione",
            "imports": "Importazioni",
            "features": "Funzionalità",
            "workers": "Worker",
            "pghero": "PgHero",
            "rsi-api-status": "Stato API RSI",
            "stats": "Statistiche"
          }
        },
        "versions": {
          "blank": "vuoto",
          "revertQuestion": "Ripristinare?",
          "sources": {
            "custom": "Admin",
            "rsi_loader": "Ship Matrix",
            "sc_data_loader": "File di gioco",
            "sc_loader": "File di gioco",
            "uex_price_sync": "Sincronizzazione prezzi UEX",
            "unknown": "Sconosciuto"
          }
        }
      },
      "hangarTable": {
        "extraColumns": "Colonne",
        "columns": {
          "storeImage": "Immagine",
          "storeImageWide": "Immagine larga",
          "angledView": "Immagine 3D",
          "angledViewWide": "Immagine 3D larga",
          "modelManufacturerName": "Produttore",
          "modelLength": "Lunghezza",
          "modelBeam": "Larghezza",
          "modelHeight": "Altezza",
          "modelMass": "Massa",
          "modelCargo": "Carico",
          "modelMinCrew": "Equipaggio",
          "modelMaxCrew": "Equipaggio max.",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "Velocità max.",
          "modelGroundMaxSpeed": "Velocità a terra",
          "modelFocus": "Specializzazione",
          "modelProductionStatus": "Stato di produzione",
          "modelPrice": "Prezzo",
          "modelPledgePrice": "Prezzo Pledge"
        }
      },
      "fleetTable": {
        "extraColumns": "Colonne",
        "columns": {
          "storeImage": "Immagine",
          "storeImageWide": "Immagine larga",
          "angledView": "Immagine 3D",
          "angledViewWide": "Immagine 3D larga",
          "modelManufacturerName": "Produttore",
          "modelLength": "Lunghezza",
          "modelBeam": "Larghezza",
          "modelHeight": "Altezza",
          "modelMass": "Massa",
          "modelCargo": "Carico",
          "modelMinCrew": "Equipaggio",
          "modelMaxCrew": "Equipaggio max.",
          "modelScmSpeed": "SCM Speed",
          "modelMaxSpeed": "Velocità max.",
          "modelGroundMaxSpeed": "Velocità a terra",
          "modelProductionStatus": "Stato di produzione",
          "modelPrice": "Prezzo",
          "modelPledgePrice": "Prezzo Pledge",
          "owner": "Proprietario"
        }
      },
      "logistics": {
        "inventoryCount": "inventories",
        "pending": "pending",
        "entriesCount": "entries",
        "managedBy": "Managed by",
        "itemName": "Name",
        "category": "Category",
        "component": "Component",
        "componentCategory": "Component Type",
        "commodity": "Commodity",
        "commodityType": "Commodity Type",
        "equipment": "Equipment",
        "equipmentItemType": "Equipment Type",
        "quantity": "Quantity",
        "unit": "Unit",
        "notes": "Notes",
        "status": "Status",
        "requested": "Requested",
        "description": "Description",
        "priority": "Priority",
        "requestedBy": "Requested by",
        "states": {
          "draft": "Draft",
          "submitted": "Submitted",
          "rejected": "Rejected",
          "cancelled": "Cancelled"
        },
        "requestTypes": {
          "general": "General"
        },
        "priorities": {
          "standard": "Standard",
          "critical": "Critical"
        },
        "searchItems": "Search items...",
        "quality": "Quality (0-1000)",
        "qualityMin": "Quality >=",
        "qualityMax": "Quality <=",
        "existingItem": "Select existing item",
        "inventoryName": "Inventory Name",
        "visibility": "Visibility",
        "visibilities": {
          "members_only": "All Members",
          "officers_only": "Officers Only"
        },
        "inventory": "Inventory",
        "notesPlaceholder": "Add notes...",
        "entryType": "Type",
        "entryTypes": {
          "deposit": "Deposit",
          "withdrawal": "Withdrawal"
        },
        "stockView": "Current Stock",
        "logView": "Transaction Log",
        "addedBy": "Logged by",
        "member": "Member",
        "selectItem": "Select item",
        "currentStock": "Available",
        "location": "Location",
        "image": "Image",
        "categories": {
          "commodity": "Commodity",
          "component": "Component",
          "weapon": "Weapon",
          "equipment": "Equipment",
          "ammunition": "Attachments & Ammunition",
          "consumable": "Consumable",
          "other": "Other"
        },
        "units": {
          "scu": "SCU",
          "units": "Units"
        },
        "csvImportHelp": "Upload a CSV file with columns: name, category, quantity, unit, notes. Download the template for the correct format.",
        "imported": "items imported",
        "importErrors": "errors",
        "inStock": "In stock",
        "entries": "Entries",
        "lastEntry": "Last entry",
        "history": "History",
        "linkedItem": "Linked item",
        "itemUnavailable": "Not in current patch",
        "itemUnavailableHint": "The current game build no longer ships this item. Entries keep it, but it cannot be picked for new ones.",
        "qualityRange": "Quality",
        "stockItem": "Stock Item",
        "overCapacity": "oltre la capacità di carico",
        "cargoGrid": "Griglia di carico",
        "shipInventory": "Inventario della nave",
        "remaining": "Rimanente",
        "unmeasured": "%{count} non ancora misurati"
      },
      "hangarInventories": "Inventories",
      "adminNotifications": {
        "inbox": "In arrivo",
        "archive": "Archivio",
        "unreadOnly": "Solo non lette",
        "status": "Stato",
        "severity": "Gravità",
        "type": "Tipo",
        "selectPrompt": "Seleziona una notifica per leggerla",
        "noBody": "Questa notifica non contiene ulteriori dettagli.",
        "lastSeen": "Vista l'ultima volta",
        "expires": "Scade",
        "severities": {
          "info": "Info",
          "warning": "Avviso",
          "error": "Errore"
        },
        "types": {
          "paints_import": "Importazione verniciature",
          "modules_import": "Importazione moduli",
          "loaner_sync": "Sincronizzazione comodati",
          "uex_prices_import": "Sincronizzazione prezzi UEX",
          "uex_commodity_prices_import": "Sincronizzazione commodity UEX",
          "new_supporter": "Nuovo sostenitore",
          "rsi_api_blocked": "API RSI bloccata",
          "rsi_api_unblocked": "API RSI ripristinata",
          "weekly_stats": "Report settimanale",
          "ship_matrix_import": "Importazione Ship Matrix",
          "sc_data_import": "Importazione sc_data",
          "import_run": "Importazione"
        }
      },
      "optional": "facoltativo",
      "notificationActions": {
        "open": "Apri",
        "openHangar": "Apri l'hangar",
        "openWishlist": "Apri la lista dei desideri",
        "openModel": "Mostra la nave",
        "openInvite": "Vedi l'invito",
        "reviewRequest": "Esamina la richiesta",
        "openMembers": "Mostra i membri",
        "openFleet": "Apri la flotta",
        "openInventory": "Apri l'inventario",
        "openEvent": "Apri l'evento",
        "openRoster": "Mostra le iscrizioni",
        "addToCalendar": "Aggiungi al calendario",
        "openStore": "Pledge store",
        "accept": "Accetta",
        "decline": "Rifiuta",
        "signUp": "Iscriviti",
        "withdraw": "Ritirati",
        "syncAgain": "Sincronizza di nuovo",
        "markAsBought": "Segna come acquistata",
        "unavailable": "Non è più disponibile."
      },
      "notificationTypes": {
        "channels": {
          "app": "App",
          "mail": "Email",
          "push": "Push",
          "discord": "Discord"
        },
        "groups": {
          "account": "Account e hangar",
          "fleetMembership": "Iscrizione alla flotta",
          "fleetEvents": "Eventi della flotta"
        },
        "hangar_create": "Hangar creato",
        "hangar_destroy": "Hangar rimosso",
        "hangar_sync_finished": "Sincronizzazione hangar completata",
        "hangar_sync_failed": "Sincronizzazione hangar fallita",
        "wishlist_create": "Aggiunta alla lista dei desideri",
        "wishlist_destroy": "Rimossa dalla lista dei desideri",
        "model_on_sale": "Modello in vendita",
        "new_model": "Nuovo modello rilasciato",
        "fleet_invite": "Invito a una flotta ricevuto",
        "fleet_member_requested": "Richiesta di iscrizione",
        "fleet_member_accepted": "Iscrizione accettata",
        "fleet_request_accepted": "Richiesta di partecipazione accettata",
        "fleet_inventory_item_added": "Oggetto aggiunto all'inventario della flotta",
        "fleet_event_published": "Evento pubblicato",
        "fleet_event_locked": "Iscrizioni all'evento bloccate",
        "fleet_event_starting_soon": "Evento in partenza",
        "fleet_event_started": "Evento avviato",
        "fleet_event_completed": "Evento completato",
        "fleet_event_cancelled": "Evento annullato",
        "fleet_event_signup_added": "Nuova iscrizione",
        "fleet_event_signup_withdrawn": "Iscrizione ritirata",
        "fleet_event_signup_confirmed": "Iscrizione confermata",
        "fleet_event_signup_assigned": "Assegnato a uno slot",
        "fleet_event_signup_kicked": "Rimosso da uno slot",
        "allInGroup": "Tutto in questo gruppo"
      },
      "fleets": {
        "missions": {
          "title": "Titolo",
          "description": "Descrizione",
          "team": "Team",
          "teams": "Team",
          "ship": "Nave",
          "ships": "Navi",
          "slot": "Slot",
          "slots": "Slot",
          "noMissions": "Ancora nessuna missione.",
          "noTeams": "Ancora nessun team aggiunto.",
          "noShips": "Ancora nessuna nave aggiunta.",
          "noSlots": "Ancora nessuno slot aggiunto.",
          "archivedTab": "Archiviate",
          "activeTab": "Attive",
          "archived": "Archiviata",
          "modelSpecific": "Nave specifica",
          "modelList": "Una di queste",
          "modelListHint": "Il posto accetta una qualsiasi delle navi che scegli.",
          "allowedShips": "Navi compatibili",
          "anyOf": "Una di",
          "filterRange": "Intervallo del filtro",
          "classification": "Classificazione",
          "focus": "Specializzazione",
          "minSize": "Dimensione min.",
          "maxSize": "Dimensione max.",
          "minCrew": "Equipaggio min.",
          "minCrewOverride": "Sovrascrivi",
          "minCrewOverrideLabel": "Sovrascrittura equipaggio min.",
          "minCrewOverrideHint": "Lascia vuoto per usare l'equipaggio minimo predefinito della nave.",
          "minCargo": "Carico min. (SCU)",
          "createdBy": "Creata da",
          "seats": "Posti",
          "category": "Categoria",
          "coverImage": "Immagine di copertina",
          "coverPresets": "Scegli tra gli esempi",
          "scenario": "Scenario",
          "categories": {
            "other": "Altro",
            "ship_combat": "Combattimento spaziale",
            "ground_combat": "Combattimento terrestre",
            "combined_combat": "Combattimento combinato",
            "mining": "Estrazione mineraria",
            "salvage": "Recupero",
            "cargo_hauling": "Trasporto merci",
            "exploration": "Esplorazione"
          }
        },
        "events": {
          "title": "Titolo",
          "description": "Descrizione",
          "briefing": "Briefing",
          "startsAt": "Inizia il",
          "endsAt": "Termina il",
          "timezone": "Fuso orario",
          "location": "Luogo dell'evento",
          "meetupLocation": "Luogo di ritrovo",
          "visibility": "Visibilità",
          "maxAttendees": "Partecipanti max.",
          "autoLockEnabled": "Blocca automaticamente le iscrizioni",
          "autoLockMinutesBefore": "Minuti prima dell'inizio per il blocco",
          "recurring": "Si ripete",
          "recurringHint": "Genera automaticamente questo evento a intervalli regolari. I membri si iscrivono a ogni singola occorrenza.",
          "recurringSummary": "Si ripete %{interval}",
          "recurringUntil": "Si ripete %{interval} fino al %{date}",
          "recurringForCount": "Si ripete %{interval} (%{count} occorrenze)",
          "viewSeries": "Vedi la serie",
          "recurrenceInterval": "Ripeti ogni",
          "recurrenceEnd": "Termina",
          "recurrenceEndNever": "Mai",
          "recurrenceEndOn": "In data",
          "recurrenceEndAfter": "Dopo",
          "recurrenceEndOccurrences": "occorrenze",
          "recurrence": {
            "daily": "ogni giorno",
            "weekly": "ogni settimana",
            "biweekly": "ogni due settimane",
            "monthly": "ogni mese"
          },
          "occurrencesSection": "Prossime occorrenze",
          "skipOccurrence": "Salta questa occorrenza",
          "overrideOccurrence": "Sovrascrivi l'occorrenza del %{date}",
          "overrideOccurrenceShort": "Modifica solo questa",
          "overrideOccurrenceHint": "Sovrascrivi i campi per questa singola occorrenza. Lascia vuoto per ereditarli dall'evento ricorrente.",
          "endSeriesHere": "Interrompi da qui in avanti",
          "excludedBadge": "Saltata",
          "noUpcomingOccurrences": "Nessuna occorrenza in programma nelle prossime 12 settimane.",
          "endSeriesConfirm": "Vuoi interrompere la ricorrenza dopo questa data? Le occorrenze future non verranno generate.",
          "skipOccurrenceSuccess": "Occorrenza saltata.",
          "endSeriesSuccess": "Serie terminata a partire da questa data.",
          "cancelledReason": "Motivo dell'annullamento",
          "createdBy": "Creato da",
          "signups": "Iscrizioni",
          "signupsCount": "%{count} iscrizioni",
          "youAreHere": "Sei qui",
          "attendance": "Partecipazione",
          "signupsLockedHint": "Le iscrizioni a questo evento sono bloccate.",
          "alreadySignedUpHint": "Sei già iscritto a un altro slot. Ritirati prima di cambiare.",
          "slotTakenHint": "Questo slot è già occupato.",
          "currentSlot": "Slot attuale",
          "currentSlotHint": "Questo è lo slot in cui si trova attualmente l'iscrizione.",
          "takenBy": "Occupato da %{username}",
          "slotPickerHint": "Scegli uno slot per questa iscrizione. Gli slot già occupati o non disponibili sono disattivati.",
          "signupCtaHint": "Iscriviti all'evento — puoi scegliere subito uno slot specifico oppure farti assegnare più tardi da un admin.",
          "noSlotYet": "Ancora nessuno slot",
          "signupApproval": "Approvazione delle iscrizioni",
          "signupStatuses": {
            "confirmed": "Confermata",
            "tentative": "Non definitiva",
            "interested": "Interessato",
            "pending": "In attesa di approvazione",
            "withdrawn": "Ritirata"
          },
          "signupApprovals": {
            "direct": "Diretta",
            "confirmation_required": "Richiede conferma"
          },
          "unassignedSignupsHint": "Questi membri si sono iscritti all'evento ma non hanno ancora uno slot. Assegnali qui sotto oppure rimuovi l'iscrizione.",
          "taken": "Occupato",
          "grantedRoles": "Ruoli assegnati",
          "noEventAdminsYet": "Ancora nessun admin o moderatore aggiuntivo.",
          "creator": "Creatore dell'evento",
          "eventTeamHint": "Assegna ad altri membri i diritti di admin o moderatore per questo evento. Gli admin possono modificarlo, i moderatori possono gestire le iscrizioni.",
          "eventRole": "Ruolo",
          "eventRoles": {
            "admin": "Admin",
            "moderator": "Moderatore"
          },
          "memberPicker": "Membro",
          "spawnedEvents": "Eventi generati",
          "fromMission": "Dalla missione",
          "pickTemplate": "Scegli un modello",
          "pickTemplateHint": "Puoi partire da un modello di missione — i campi verranno precompilati e l'evento resterà collegato ad esso.",
          "noTemplate": "Nessun modello",
          "noTemplateHint": "Crea l'evento da zero.",
          "changeTemplate": "Cambia modello",
          "clearTemplate": "Rimuovi il modello",
          "myVehicle": "Il mio veicolo",
          "selectVehicle": "Seleziona un veicolo (facoltativo)",
          "vehicleMismatchHint": "Il veicolo selezionato non soddisfa i requisiti di questo slot.",
          "noFittingInHangar": "Niente nel tuo hangar è adatto a questo slot. Puoi comunque iscriverti lasciando vuoto il veicolo.",
          "vehicleFitsHint": "Porta un veicolo adatto a questa nave.",
          "noMatchingVehicle": "Nessuna iscrizione porta un veicolo adatto.",
          "shipNotCrewedYet": "Ancora nessuna iscrizione adatta.",
          "expandHint": "%{model} ha %{count} posti in più. Vuoi aggiungere degli slot così che altri possano occuparli?",
          "notes": "Note",
          "upcomingTab": "In programma",
          "pastTab": "Passati",
          "archivedTab": "Archiviati",
          "listTab": "Elenco",
          "calendarTab": "Calendario",
          "subscribeHint": "Copia negli appunti l'URL del feed del calendario così puoi incollarlo nella tua app calendario.",
          "visibilities": {
            "members": "Membri",
            "officers": "Ufficiali",
            "fleet": "Pubblico"
          },
          "statuses": {
            "draft": "Bozza",
            "open": "Iscrizioni aperte",
            "locked": "Iscrizioni bloccate",
            "active": "In corso",
            "completed": "Completato",
            "cancelled": "Annullato",
            "past": "Passato"
          },
          "tabs": {
            "basic": "Informazioni di base",
            "description": "Descrizione e copertina",
            "teams": "Team e navi",
            "overview": "Panoramica",
            "settings": "Impostazioni"
          },
          "calendar": {
            "month": "Mese",
            "week": "Settimana",
            "weekTitle": "Settimana del %{date}"
          },
          "repeats": "Ricorrente"
        }
      },
      "commodity": {
        "commodityType": "Commodity Type",
        "uexId": "UEX ID",
        "uexCode": "UEX Code",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "equipment": {
        "equipmentType": "Equipment Type",
        "itemType": "Item Type",
        "subType": "Sub Type",
        "weaponClass": "Weapon Class",
        "slot": "Slot",
        "size": "Size",
        "grade": "Grade",
        "hidden": "Hidden?",
        "scKey": "SC Key",
        "scRef": "SC Ref",
        "storeImage": "Store Image"
      },
      "notifications": {
        "inbox": "In arrivo",
        "archive": "Archivio",
        "unreadOnly": "Solo non lette",
        "status": "Stato",
        "type": "Tipo",
        "selectPrompt": "Seleziona una notifica per leggerla",
        "noBody": "Questa notifica non contiene ulteriori dettagli.",
        "archivesOn": "Passa in archivio il",
        "deletesOn": "Eliminata il"
      },
      "unlistedModel": {
        "linkHint": "Quale nave del catalogo è %{identifier}? Il suggerimento viene dall'export e può essere sbagliato."
      },
      "slug": "Slug",
      "inventories": {
        "source": "Origine",
        "sources": {
          "vehicle": "Nave",
          "handMade": "Creato a mano"
        }
      },
      "inventoryItems": {
        "name": "Nome",
        "category": "Categoria",
        "entryType": "Movimento",
        "quantity": "Quantità",
        "quality": "Qualità",
        "notes": "Note",
        "itemType": "Catalogo",
        "categories": {
          "commodity": "Merce",
          "component": "Componente",
          "weapon": "Arma",
          "equipment": "Equipaggiamento",
          "ammunition": "Munizioni",
          "consumable": "Consumabile",
          "other": "Altro"
        },
        "entryTypes": {
          "deposit": "Deposito",
          "withdrawal": "Prelievo"
        },
        "units": {
          "scu": "SCU",
          "units": "unità"
        }
      },
      "scDataSource": {
        "dataSource": "Fonte dati",
        "notLive": "Non è la build live"
      },
      "erkul": {
        "prefix": "Prova Loadouts con",
        "link": "Calcolatore DPS Di Erkul"
      },
      "shipHistory": {
        "sales": "Storico delle offerte",
        "salesCount": "Offerte registrate",
        "lastSale": "Ultima offerta",
        "averageGap": "Intervallo medio",
        "days": "%{count} giorni",
        "ongoing": "In corso",
        "priceHistory": "Storico del prezzo pledge",
        "firstPriced": "Primo prezzo",
        "priceRemoved": "Prezzo rimosso",
        "wishlist": "Aggiunte alla lista dei desideri per mese",
        "patchChanges": "Modifiche della patch",
        "notRecordedYet": "Registrato solo da quando è iniziato il tracciamento, quindi una nave può non avere nulla."
      }
    }
  }
}
